module.exports = __webpack_public_path__ + "files/a6dedde9baed7bfa25db3e7e79c0da8a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-bold-webfont.svg
 ** module id = 932
 ** module chunks = 0
 **/